import service from '@/services/superaccess'

const reception = {
  state: {
    modal_reception: false
  },
  mutations: {
    setModalStatusReception (state, status) {
      state.modal_reception = status
    }
  },
  getters: {
    getModalStatusReception (state) {
      return state.modal_reception
    }
  },
  actions: {
    searhPersonReception (context, payload) {
      return service.post('/api/reception/all', context, { search: payload })
    },
    showPersonReception (context, payload) {
      return service.post('/api/reception/show', context, { person: payload })
    },
    retrieveDetailsReception (context, payload) {
      return service.get('/api/reception/new', context)
    },
    createReception (context, payload) {
      return service.post('/api/reception/create', context, { data: payload })
    },
    changeReception (context, payload) {
      return service.post('/api/reception/change', context, { data: payload })
    },
    changeModalStatusReception (context, payload) {
      context.commit('setModalStatusReception', payload)
    },
    setModalStatusReception (state, status) {
      state.modal_reception = status
    },
    createNovelty (context, payload) {
      return service.post('/api/authorization/create', context, { authorization: payload })
    },
    changeNovelty (context, payload) {
      return service.put('/api/authorization/change', context, { data: payload })
    },
    retrieveMovementConfig (context, payload) {
      return service.post('/api/reception/check-config', context)
    },
    recordMovement (context, payload) {
      return service.post('/api/reception/record-movement', context, { data: payload })
    },
    retrieveLastMovement (context, payload) {
      return service.post('/api/reception/last-movement', context, { id: payload })
    },
    countAuthoDatatable (context, payload) {
      return service.post('/api/authorization/count', context, { autho_id: payload })
    },
    countMoveDatatable (context, payload) {
      return service.post('/api/movement/count', context, { autho_id: payload })
    },
    getMoveImages (context, payload) {
      return service.post('/api/movement-picture', context, { id: payload })
    },
    checkPersonBiometrics (context, payload) {
      return service.post('/api/biometrics/check', context, { data: payload })
    },
    checkPersonTrainings (context, payload) {
      return service.post('/api/training/missing', context, { data: payload })
    },
    checkPersonDeclaration (context, payload) {
      return service.post('/api/training/declaration_missing', context, { data: payload })
    },
    isTraining (context, payload) {
      return service.post('/api/training/is_training', context, { data: payload })
    },
    countTrainingDatatable (context, payload) {
      return service.post('/api/training/count', context, { data: payload })
    }
  }
}

export default reception



// WEBPACK FOOTER //
// app/javascript/src/store/reception.js